// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a9748930","849":"dd35549d"}[chunkId] + ".chunk.js";
};